/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { StartDate } from './';
import {
    StartDateFromJSON,
    StartDateFromJSONTyped,
    StartDateToJSON,
} from './';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface StartDateField
 */
export interface StartDateField extends UpdatedField {
    /**
     * 
     * @type {StartDate}
     * @memberof StartDateField
     */
    startDate: StartDate;
}

/**
 * Check if a given object implements the StartDateField interface.
 */
export function instanceOfStartDateField(value: object): value is StartDateField {
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    return true;
}

export function StartDateFieldFromJSON(json: any): StartDateField {
    return StartDateFieldFromJSONTyped(json, false);
}

export function StartDateFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartDateField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'startDate': StartDateFromJSON(json['startDate']),
    };
}

export function StartDateFieldToJSON(value?: StartDateField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'startDate': StartDateToJSON(value['startDate']),
    };
}

